module.exports = __webpack_public_path__ + "img/品質管理4-1.073f4083.png";